/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
export var InputShiftType = /*@__PURE__*/ (function (InputShiftType) {
    InputShiftType[InputShiftType["Line"] = 0] = "Line";
    InputShiftType[InputShiftType["Box"] = 1] = "Box";
    InputShiftType[InputShiftType["Border"] = 2] = "Border";
    return InputShiftType;
})({});
/**
 * @hidden
 */
export var InputShiftType_$type = /*@__PURE__*/ markEnum('InputShiftType', 'Line,0|Box,1|Border,2');
//# sourceMappingURL=InputShiftType.js.map
